export default __webpack_public_path__ + "static/media/RCYCLE_Logo_green_blue-400x.28c558cb.png";